export function isInternalHref(href: string) {
  try {
    const u = new URL(href, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    return u.origin === (typeof window !== 'undefined' ? window.location.origin : u.origin);
  } catch {
    return href.startsWith('/');
  }
}

export function scrollToAnchor(anchor: string) {
  const el = document.getElementById(anchor);
  if (!el) return;
  const isMobile = window.innerWidth < 768;
  const offset = isMobile ? 80 : 120;
  const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
}
